import { FC } from 'react';
import { Typography } from '@mui/material';
import { ContactInfoItemProps } from './types';

const ContactInfoItem: FC<ContactInfoItemProps> = ({ contact }) => (
  <Typography variant="body1">
    <Typography component="span" variant="subtitle1">
      {contact.type}:
    </Typography>{' '}
    {contact.value}
  </Typography>
);

export default ContactInfoItem;
